import styled from 'styled-components';
import { fontStyle } from '../../../styles/mixins';
import {
  FONT_SIZE_6,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_NORMAL,
  GRAY_MEDIUM,
} from '../../../styles/variables';

export const MenuList = styled.ul`
  margin-top: 40px;
  padding: 0;
  margin-bottom: 0;
  max-height: 320px;
  overflow-y: auto;
  ${props => props.customStyle}
`;

export const MenuItem = styled.li`
  margin-bottom: 25px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const MarketplacesName = styled.h3`
  ${fontStyle('#FFF', FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  margin-bottom: 5px;
  text-transform: capitalize;
`;

export const MenuType = styled.p`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_6, FONT_WEIGHT_NORMAL)}
  margin: 0;
`;



// WEBPACK FOOTER //
// ./src/components/CreateMenuModal/MenuListHelper/style.js